<template>
  <div>
    <Breadcrumb style="margin: 20px 10%;font-size: 18px;">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem to="/innovation">科研创新</BreadcrumbItem>
      <BreadcrumbItem>优秀科技工作者简介</BreadcrumbItem>
    </Breadcrumb>
    <div class="infoDiv">
      <div class="head"><Icon type="md-person" />基本信息</div>
      <div class="c1">
        <ul>
          <li>姓名：{{ nowIn.name }}</li>
          <li>职务/职称：{{ nowIn.title }}</li>
          <li>教育背景：{{ nowIn.colleage }}</li>
          <li>专业方向：{{ nowIn.major }}</li>
          <li>手机：{{ nowIn.phone }}</li>
          <li>邮箱：{{ nowIn.email }}</li>
        </ul>
        <img :src="nowIn.img" alt="" class="photo">
      </div>
      <div class="head">
        <Icon type="md-albums" />个人简介
      </div>
      <div class="c2">
        <p class="c2p" v-for="phase in nowIn.introduce" :key="phase">{{phase}}</p>
      </div>
      <div class="head">
        <Icon type="md-ribbon" />成果和荣誉
      </div>
      <div class="c3">
        <Timeline style="padding-left:16px;">
          <TimelineItem>
              <p class="time">获得的奖项</p>
              <p class="content">暂无</p>
          </TimelineItem>
          <TimelineItem>
              <p class="time">发表的论文</p>
              <p class="content">暂无</p>
          </TimelineItem>
          <TimelineItem>
              <p class="time">申请的专利</p>
              <p class="content">暂无</p>
              <!-- <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent1.png" alt="" width="150px"> -->
          </TimelineItem>
        </Timeline>
      </div>
      <div class="head">
        <Icon type="ios-archive" />代表项目
      </div>
      <div class="c4">
        <ul>
          <li v-for="item in p2" :key="item" style="margin: 20px 0;">
            <span @click="toInnovation(item.id)">{{item.title}}</span>
            <!-- <img :src="item" alt="" width="500px" @click="toInnovation(item)"> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "participants",
  components: {},
  data() {
    return {
      information: [
        {
          id: 1,
          name: "何增胜",
          colleage: "博士（研究生）",
          title: '',
          major: "土木工程、计算机视觉",
          phone: "15521207968",
          email: "421522407@qq.com",
          introduce: ["何增胜，男，在读博士研究生，主要从事结构健康监测、计算机视觉和人工智能等方面的研究。"],
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/participants1.jpg"
        },
        {
          id: 2,
          name: "滕昊锦",
          colleage: "硕士（研究生）",
          title: "",
          major: "土木工程 桥隧方向",
          phone: "18879316508",
          email: "haojinteng@163.com",
          introduce: [
            "滕昊锦，男，在读硕士研究生，主要从事结构健康监测、桥梁车辆荷载效应分析等方面的研究。",
            "参与项目结构健康监测云平台的架构设计；参与项目融合Cloud-BIM信息技术的城市基础设施集群式健康监测平台桥梁车辆荷载效应分析模块的研发，根据车辆荷载信息开展结构动力响应在线分析。"
          ],
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/participants2.jpg"
        },
      ],
      projects: [
        '基于计算机视觉技术的车辆荷载识别系统研发',
        '区域级SHM融合云平台关键技术研发',
        '基于PeraSIM的SHM在线评估系统研发'
      ],
      p2: [
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/p1.png',
          title: '结构健康监测云平台',
          id: 1
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/p2.png',
          title: '面向区域级结构健康监测与安全评估的CLOUD-BIM决策支持平台关键技术研究',
          id: 999
        },
        // {
        //   img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/p3.png',
        //   title: '结构健康监测云平台',
        //   id: 999
        // }
      ],
      idNum: 1,
      nowIn: {}
    };
  },
  created(){
    let id = this.$route.query.id
    if(id){
      this.idNum = id
      this.nowIn = this.information.find(item => item.id==this.idNum)
    }
    else{
      this.$emit('changeProduce', 'innovation')
    }
  },
  methods: {
    toInnovation(id){
      this.$emit("changeProduce", 'innovation_detail', null, id);
    }
  }
};
</script>
<style lang="less" scoped>
.infoDiv{
  width: 100%;
  display: flex;
  flex-direction: column;
  .c1{  
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 60%;
    margin: 10px auto;
    background-color: #dcdee2;
    border-radius: 15px;
    ul{
      margin: 0 0;
      padding: 16px;
      list-style: none;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 80%;
      justify-content: space-between;
      li{
        margin: 10px 0;
        padding: 0;
        list-style: none;
        display: block;
        width: 45%;
        font-size: 16px;
      }
    }
    .photo{
      display: block;
      width: 20%;
    }
  }
  .c1:hover, .c2:hover{
    box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
    transition: all 0.5s ease-in-out;
  }
  .c2{
    width: 60%;
    height: 150px;
    margin: 10px auto;
    padding: 16px;
    background-color: #dcdee2;
    border-radius: 15px;
    .c2p{
      font-size: 16px;
      line-height: 1.5em;
      margin: 10px 0;
    }
  }
  .c3{
    width: 60%;
    display: block;
    margin: 0 auto;
    .time{
      font-size: 16px;
      font-weight: bold;
    }
    .content{
      padding-left: 5px;
      font-size: 16px;
      line-height: 2em;
    }
  }
  .c4{
    width: 60%;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
    padding-left: 40px;
    li{
      // display: block;
      margin: 10px 0;
      font-size: 18px;
      cursor: pointer;
    }
    li:hover{
      text-decoration: solid #6699CC;
      color: #6699CC;
    }
  }
}

.head{
  display: block;
  width: 150px;
  padding: 16px;
  font-size: 18px;
  text-align: center;
  color: #000;
  border: 1px solid #dcdee2;
  margin: 20px 0 20px 20%;
  border-radius: 15px;
  background-color: #6699CC;
}

</style>
